module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABpSURBVHgB7dPRCYAwDATQSyfoKI6gG7iBruYEjuIqbhBTrCD9ESH5aJsHB/0od1Ao0AVmjpJdMkBbLj/4NkNTUb5Ck5c3Vp4HTMrD63w+W7BQPNECCz7iI8mIn8LXBSJK/2OSbJIIV50LEZffajBqsXEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/Back.png
// module id = +TZ4
// module chunks = 1